import React, {Component} from 'react';
import Dialog from 'material-ui/Dialog';
class SuspendUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ifDisabledBtn: false
    }
  }
  handleClose () {
    this.props.closeSuspendUser();
    this.props.clearSuspendError();
    this.setState({
      ifDisabledBtn: false
    })
  }
  handleSuspendUser () {
    // the second param canbe suspend or reactivate, this action will call window.location.reload() to reload page in the employees actions's file.
    // notice: the default value of isClientUser was judged via pathname, which is `/employees/user-status/`.
    if (!this.props.suspended) {
      this.props.suspendUser(this.props.suspendUserId, 'suspend', !this.props.isClientUser);
    } else {
      this.props.suspendUser(this.props.suspendUserId, 'reactivate', !this.props.isClientUser)
    }
    this.setState({
      ifDisabledBtn: true
    })
  }
  render () {
    return (
      <div className="suspend-user">
        <Dialog
          modal={true}
          contentStyle={{ width: '45%' }}
          open={this.props.open}
        >
          <p style={{textAlign: 'center', color: 'black', fontWeight: 'bolder'}}>
            Are you sure you would like to  {this.props.suspended ? 'reactivate' : 'suspend'} this user?
          </p>
          <div className="btns" style={{textAlign: 'center'}}>
            <button onClick={() => this.handleClose()} style={{marginRight: '1em', padding: '4px 9px', font: 'black', border: '1px solid black', borderRadius: '0', color: 'black', fontSize: '14px'}}>CANCEL</button>
            <button disabled={this.state.ifDisabledBtn} onClick={() => this.handleSuspendUser()} style={{border: this.state.ifDisabledBtn ? 'none' : '1px solid #e22121', padding: '0.3em 0.4em', color: 'white', background: '#e22121', borderRadius: '0', fontSize: '14px'}}>
              {this.props.suspended ?
                (
                  this.props.businessUnitTeamMemberPage ? 'REACTIVATE BUSINESS UNIT TEAM MEMBER' :
                  (/^(administrator|team member)/gi.test(this.props.roleName) && /^\/clients\/edit\/Client-Team-Members/.test(this.props.location.pathname)) ?
                    'REACTIVATE BUSINESS UNIT TEAM MEMBER' :
                    'REACTIVATE USER'
                )
                :
                (
                  this.props.businessUnitTeamMemberPage ? 'SUSPEND BUSINESS UNIT TEAM MEMBER' :
                    (/^(administrator|team member)/gi.test(this.props.roleName) && /^\/clients\/edit\/Client-Team-Members/.test(this.props.location.pathname)) ?
                      'SUSPEND BUSINESS UNIT TEAM MEMBER' :
                      'SUSPEND USER'
                )
              }
            </button>
          </div>
          <p style={{color: 'red', textAlign: 'center', marginTop: '0.4em', fontSize: '12px'}}>
            {this.props.suspend_error}
          </p>
        </Dialog>
      </div>
    )
  }
}

export default SuspendUser


// WEBPACK FOOTER //
// ./src/components/Employees/SuspendUser.jsx